import { useContext, useEffect, useState } from "react";
import Highlighter from "react-highlight-words";
import { getQueryParam } from "../../router/utils";
import HelpButton from "./HelpButton";
import ThemeContext from "../../context/theme/ThemeContext";

const ElementInputLabel = ({ element }) => {
	const { withTheme } = useContext(ThemeContext);
	const [highlighted, setHighlighted] = useState(false);

	useEffect(() => {
		setHighlighted(getQueryParam("element") === element.elementName);

		const eventHandler = () => {
			setHighlighted(getQueryParam("element") === element.elementName);
		};

		window.addEventListener("popstate", eventHandler);

		return function cleanup() {
			window.removeEventListener("popstate", eventHandler);
		};
	}, []);

	return (
		<div className="d-flex align-items-center" style={{ textAlign: "left", marginBottom: 4 }}>
			<Highlighter
				className={withTheme("input-label")}
				highlightStyle={{ backgroundColor: "yellow" }}
				// Highlight only if the element name is in query param "element"
				searchWords={
					highlighted
						? [element.parenthesisCode, ...element.textDescription.split(" ")]
						: []
				}
				autoEscape={true}
				textToHighlight={`${element.parenthesisCode || ""} ${element.textDescription}`}
			/>
			{element.description && (
				<HelpButton helpText={element.description} style={{ marginLeft: 8, height: 16 }} />
			)}
		</div>
	);
};

export default ElementInputLabel;
